<!--
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-04-22 11:44:44
 * @LastEditors: liujunyao
 * @LastEditTime: 2022-04-22 14:05:30
 * @FilePath: /privacy-web/src/components/PrivacyProtect/ScienceIntegrityItem.vue
-->
<template>
  <div class="integrity-item-main" :class="{ 'integrity-item-main-mobile': isMobile }">
    <div class="header">{{ data.title }}</div>
    <div class="main">{{ data.content }}</div>
  </div>
</template>
<script>
export default {
  name: "ScienceIntegrityItem",
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style lang="scss" scoped>
.integrity-item-main {
  margin: 0 calc($multiple * 6px);
  width: calc($multiple * 507px);
  height: calc($multiple * 292px);
  background: #fff;
  box-shadow: 0px 2px 12px 2px rgba(226, 226, 226, 0.59);
  border-radius: 2px;
  .header {
    border-radius: 3px 3px 0 0;
    width: 100%;
    height: calc($multiple * 90px);
    box-shadow: 0 3px 16px 3px rgb(226 226 226 / 59%);
    font-size: calc($multiple * 20px);
    font-family: PingFangTC-Medium, PingFangTC;
    font-weight: 500;
    color: #ffffff;
    line-height: calc($multiple * 28px);
    letter-spacing: 1px;
    text-align: center;
    background: url("~assets/images/privacyProtect/protect-science.png") no-repeat;
    background-size: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .main {
    height: calc($multiple * 202px);
    font-size: calc($multiple * 14px);
    padding: calc($multiple * 22px) calc($multiple * 33px) 0 calc($multiple * 44px);
    font-family: PingFangTC-Regular, PingFangTC;
    font-weight: 400;
    color: #000000;
    line-height: calc($multiple * 37px);
    letter-spacing: 1px;
  }
}
.integrity-item-main-mobile {
  margin-top: 1.02rem;
  border-radius: 0.1rem;
  width: 17.15rem;
  min-height: 12.8rem;
  height: auto;
  background: #fff;
  box-shadow: 0px 10px 61px 10px rgba(226, 226, 226, 0.59);
  .header {
    box-shadow: none;
    width: 100%;
    height: 3.3rem;
    font-size: 0.82rem;
    letter-spacing: 0.05rem;
    text-align: center;
    color: #fff;
    background: url("~assets/images/privacyProtect/protect-science.png") no-repeat;
    background-size: cover;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .main {
    padding: 0.48rem 1.6rem 0rem 1.7rem;
    height: 11.9rem;
    font-size: 0.72rem;
    line-height: 1.59rem;
    color: #4a4a4a;
    opacity: 1;
  }
}
</style>
